import React from "react";
import { Button, dialog, InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import NavBar from "../../../../components/navigation";
import FormFactory from "../../../../components/FormFactory";
import withRouter from "../../../../withRouter";
import PerformanceTable from "../../../MyPerformance/my-component/PerformanceTable";
import PerformanceFormPresenter from "./PerformanceFormPresenter";
import FileUpload from "../../../../components/common/FileUpload";
import InputFactory from "../../../../components/InputFactory";

class PerformanceFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, modifyFiles: null, advanced: false };
    this.presenter = new PerformanceFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  getCollectionName() {
    return "performance";
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  async handleApproveBtn() {
    this.presenter.submitData("Approved");
  }

  handleFileChange(modifyFiles) {
    this.setState({ modifyFiles });
  }
  handleRejectBtn() {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Reject Request Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to proceed.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.presenter.submitData("Rejected")}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  handleRatingClick() {
    this.setState((prevState) => ({ isRating: !prevState.isRating }));
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <div className="row g-3">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <FormFactory
                      schema={schema}
                      disabled={true}
                      object={object}
                      onChange={this.onChange.bind(this)}
                      excludeFields={[
                        "performance",
                        "selectedFiles",
                        "supervisor",
                        "stats",
                        "modifyFiles",
                        "assignedEmployee",
                        "employee",
                      ]}
                    />
                  )}
                </div>
                <div>
                  {Object.keys(object).length > 0 && (
                    <PerformanceTable
                      tableHeader={
                        object.type === "IPCR"
                          ? [
                              "#",
                              "Output",
                              "(Targets + Measures)",
                              "Actual Accomplishments",
                              "%Distribution",
                              "Q1",
                              "E2",
                              "T3",
                              "A4",
                              "Ave",
                              "Remarks",
                              "Actions",
                            ]
                          : object.type === "OPCR"
                          ? [
                              "#",
                              "Unit Outcome",
                              "(Targets + Measures)",
                              "Allotted Budget",
                              // "Individuals Accountable",
                              "Actual Accomplishments",
                              "Q1",
                              "E2",
                              "T3",
                              "A4",
                              "Remarks",
                              "Actions",
                            ]
                          : object.type === "DPCR"
                          ? [
                              "#",
                              "Division Outcome",
                              "(Targets + Measures)",
                              "Allotted Budget",
                              "Section Accountable",
                              "Actual Accomplishments",
                              "%Distribution",
                              "Q1",
                              "E2",
                              "T3",
                              "A4",
                              "Ave",
                              "Remarks",
                              "Actions",
                            ]
                          : [
                              "#",
                              "Section Outcome",
                              "(Targets + Measures)",
                              "Allotted Budget",
                              "Actual Accomplishments",
                              "Q1",
                              "E2",
                              "T3",
                              "A4",
                              "Remarks",
                              "Actions",
                            ]
                      }
                      tableBody={Object.keys(object.performance[0])}
                      handleRatingClick={this.handleRatingClick.bind(this)}
                      isRating={this.state.isRating}
                      object={object?.performance}
                      disabled={true}
                    />
                  )}
                </div>

                {object?.performance?.length > 0 && (
                  <div className="row  text-center">
                    <div className="col-lg-6 fs-6">
                      <div>
                        <label
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "center",
                          }}
                          colSpan={7}
                        >
                          <b>TOTAL RATING</b>
                        </label>
                        <label
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "center",
                          }}
                          colSpan={3}
                        >
                          {object.type === "OPCR" || object.type === "SPCR"
                            ? object?.performance
                                ?.reduce(
                                  (sum, item) => sum + parseFloat(item.average),
                                  0
                                )
                                .toFixed(2)
                            : object?.performance
                                ?.reduce(
                                  (sum, item) =>
                                    sum + parseFloat(item.averagedeci),
                                  0
                                )
                                .toFixed(2)}
                        </label>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div>
                        <label
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "center",
                          }}
                          colSpan={7}
                        >
                          <b>FINAL AVERAGE RATING</b>
                        </label>
                        <label
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "center",
                          }}
                          colSpan={3}
                        >
                          {object.type === "OPCR" || object.type === "SPCR"
                            ? object?.performance
                                ?.reduce(
                                  (sum, item) =>
                                    sum +
                                    parseFloat(item.average) /
                                      object.performance.length,
                                  0
                                )
                                .toFixed(2)
                            : object?.performance
                                ?.reduce(
                                  (sum, item) =>
                                    sum + parseFloat(item.averagedeci),
                                  0
                                )
                                .toFixed(2)}
                        </label>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-lg-12 mt-5">
                  <InputFactory
                    type="File"
                    disabled={true}
                    // onChange={this.handleFileChange2.bind(this)}
                    value={this.state.object.selectedFiles}
                    className="form-control"
                  />
                </div>
                {
                  <div className="col-lg-12 mt-5">
                    <InputFactory
                      type="File"
                      disabled={true}
                      onChange={this.handleFileChange.bind(this)}
                      value={this.state.object.modifyFiles}
                      className="form-control"
                    />
                  </div>
                }

                <div className="mt-4">
                  {object.stats === "Pending" && (
                    <>
                      <button
                        // type="submit"
                        className="btn btn-primary fs-sm me-3"
                        onClick={() => this.handleApproveBtn()}
                      >
                        <i className="bi bi-file-earmark-check me-2"></i>
                        Approved
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger fs-sm me-3"
                        onClick={() => this.handleRejectBtn()}
                      >
                        <i className="bi bi-x-square me-2"></i>
                        Reject
                      </button>
                    </>
                  )}
                  <button
                    type="button"
                    className="btn btn-light fs-sm"
                    onClick={this.onClickBack.bind(this)}
                  >
                    GO BACK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(PerformanceFormPage);
